import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';

const DoorLiteLocation = ({ value, onChange, isVisible, label = 'Location' }) => {
    const [selectedDoorLiteLocation, setSelectedDoorLiteLocation] = useState(value || "Center"); // Default to "Center"

    const handleDoorLiteLocationChange = (e) => {
        const newValue = e.target.value;
        setSelectedDoorLiteLocation(newValue);
        onChange(newValue); // Notify parent of change
    };

    useEffect(() => {
        console.log("Location isVisible===>", isVisible);

        if (isVisible === 1) {
            // If visible, set the default value to "Center" only if it's not already set
            if (!selectedDoorLiteLocation || selectedDoorLiteLocation !== "Center") {
                setSelectedDoorLiteLocation("Center");
                onChange("Center");
            }
        } else {
            // Clear the state when invisible
            setSelectedDoorLiteLocation("");
        }
    }, [isVisible]);

    return (
        <div className="a-container" >
            <label style={{ display: isVisible === "1" ? 'block' : 'none' }} htmlFor="DoorLiteLocation">{label}</label>
            <select style={{ display: isVisible === "1" ? 'block' : 'none'}}
                id="DoorLiteLocation"
                value={selectedDoorLiteLocation}
                onChange={handleDoorLiteLocationChange}
            >
                <option value="" disabled hidden>Select Location</option>
                <option value="LockSide">{selectedDoorLiteLocation === 'LockSide' ? 'Lock Side ✔' : 'Lock Side'}</option>
                <option value="Center">{selectedDoorLiteLocation === 'Center' ? 'Center ✔' : 'Center'}</option>
                <option value="HingeSlide">{selectedDoorLiteLocation === 'HingeSlide' ? 'Hinge Slide ✔' : 'Hinge Slide'}</option>
            </select>
        </div>
    );
};

export default DoorLiteLocation;
